import { jsxs, jsx } from 'react/jsx-runtime';
import DialogActions from '@mui/material/DialogActions';
import { ExtendedButton } from '../../../ExtendedButton/ExtendedButton.js';
import '@apollo/client';
import '../../../utils/popupUtils.js';
import { makeStyles } from '../../../utils/stylesUtils.js';
/** Dialog's save, delete actions component */

var DialogSaveDeleteActions = function DialogSaveDeleteActions(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      onDelete = _ref.onDelete,
      loadingSave = _ref.loadingSave,
      loadingDelete = _ref.loadingDelete,
      _ref$saveText = _ref.saveText,
      saveText = _ref$saveText === void 0 ? "Save" : _ref$saveText,
      onSave = _ref.onSave;

  var _useStyles = useStyles({
    onDelete: onDelete
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  return jsxs(DialogActions, Object.assign({
    className: cx(classes.actions, className)
  }, {
    children: [onDelete && jsx(ExtendedButton, Object.assign({
      onClick: onDelete,
      variant: "outlined",
      color: "error",
      loading: loadingDelete
    }, {
      children: "Delete"
    })), jsx(ExtendedButton, Object.assign({
      loaderSize: 25,
      variant: "contained",
      color: "primary",
      loading: loadingSave,
      onClick: onSave,
      type: "submit"
    }, {
      children: saveText
    }))]
  }));
};

var useStyles = makeStyles()(function (theme, _ref2) {
  var onDelete = _ref2.onDelete;
  return {
    actions: {
      padding: theme.spacing(2, 3),
      justifyContent: onDelete ? "space-between" : "flex-end"
    }
  };
});
export { DialogSaveDeleteActions };